import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuthContext();

  if (loading) return <div>認証確認中...</div>;

  if (!user) return <Navigate to="/login" />;

  return children;
};

export default RequireAuth;